import { memo } from "react";
import { Copy, Check } from "lucide-react";

function FieldCopy({ k, v, ck, copied, onCopy, mono = false }) {
    return (
        <div className="flex items-center gap-2 text-sm">
            <div className="w-20 text-xs text-slate-500">{k}</div>
            <div className={`flex-1 ${mono ? "font-mono" : ""} font-medium truncate`}>{v}</div>
            <button data-testid={`copy-${ck}`} type="button" onClick={() => onCopy(ck, v)} className="btn-secondary px-2 py-1 rounded-md">{copied === ck ? <Check className="w-3.5 h-3.5 text-emerald-600" /> : <Copy className="w-3.5 h-3.5" />}</button>
        </div>
    );
}

// React.memo: this row sits inside the 4s status-poll re-render fan-out;
// nothing about its props changes between polls (UPI ID + copied state),
// so skipping its diff cycle each poll saves measurable work on mid-tier
// devices.
export default memo(FieldCopy);
